import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { XOKButton } from '@/components/xqxc_ui';

const modalParam = ({
    modalParam = '',
    closeModal
}) => {
    const footerNode = <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <XOKButton
            label='确定'
            onClick={closeModal}
        />
    </div>;
    return <Modal
        width={420}
        centered
        title='短信内容'
        visible={true}
        onCancel={closeModal}
        destroyOnClose={true}
        keyboard={true}
        maskClosable={false}
        footer={footerNode}
    >
        <div>{modalParam}</div>
    </Modal>;
};
modalParam.proptypes = {
    modalParam: PropTypes.string,
    closeModal: PropTypes.func
};
export default modalParam